import { parse, toSeconds } from "iso8601-duration";

// TODO: this have to be added to agent-config endpoint
// https://api-prep.travactory.com/landing-page-proxy/api/agent-config?domain=prep.tix.nl
const ABBREVIATIONS = {
  hours: "h",
  minutes: "m",
  days: "d",
};

export const formatDuration = (
  isoDuration: string,
  abbreviations = ABBREVIATIONS
) => {
  const durationSeconds = toSeconds(parse(isoDuration));

  return `${Math.floor(durationSeconds / 3600)}${abbreviations.hours} \
                           ${Math.ceil((durationSeconds % 3600) / 60)}${
    abbreviations.minutes
  }`;
};
